import React from 'react';
import { Box, Typography } from '@mui/material';

const MAINTENANCE_MESSAGE = 'Strona w przebudowie';

const WebsiteMaintenancePage = () => (
    <Box
        sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: '#f7f7f7',
            px: 2,
        }}
    >
        <Typography
            component="h1"
            variant="h4"
            sx={{ color: '#2d5016', textAlign: 'center', fontWeight: 600 }}
        >
            {MAINTENANCE_MESSAGE}
        </Typography>
    </Box>
);

export default WebsiteMaintenancePage;
